import * as actions from 'redux/actions/domainsData.actions'
import * as domainsListActions from 'redux/actions/domainsList.actions'
import * as keywordGrossingActions from 'redux/actions/keywordGrossing.actions'
import * as keywordDiscoveryActions from 'redux/actions/keywordDiscovery.actions'
import * as keywordSavingsOverviewActions from 'redux/actions/keywordSavingsOverview.actions'

const updateDomainsListItem = (existingDomain, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomainTagsSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          tags: payload.tags
        }
      }
    case actions.loadKeywordsSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          keywords: payload.keywords
        }
      }
    case actions.loadCompetitorsSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          competitors: payload.competitors
        }
      }
    case domainsListActions.loadDomainOverviewSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          ...payload.overview
        }
      }
    case keywordGrossingActions.getDomainKeywordGrossingSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          grossing: payload.grossing
        }
      }
    case keywordDiscoveryActions.getDomainKeywordDiscoverySuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          discovery: payload.discovery
        }
      }
    case keywordSavingsOverviewActions.getDomainKeywordSavingsOverviewSuccess.type:
      return {
        ...existingDomain,
        attributes: {
          ...existingDomain.attributes,
          savingsOverview: payload.savingsOverview
        }
      }
    case actions.loadDomainSuccess.type:
      if (payload.data && payload.data.attributes) {
        return {
          ...existingDomain,
          attributes: payload.data.attributes
        }
      }
      return existingDomain
    default:
      return existingDomain
  }
}

export default updateDomainsListItem
